import { Helmet } from 'react-helmet';
import {
  Box,
  Container,
  Grid
} from '@material-ui/core';
import MakeRechnung from 'src/components/rechnung/MakeRechnung';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import { useEffect } from 'react';
import { checkAutoLogin } from 'src/actions/getTokenActions';

const RechnungDashboard = () => {
  const navigate = useNavigate();
  const isLogin = useSelector(state => state.gettocken.islogin);
  const dispatch = useDispatch()
  const apiurl = sessionStorage.getItem('apiurl')

  useEffect(()=> {
    let token = checkAutoLogin(dispatch)
    if (!token && isLogin === false) {
      navigate('/login', { replace: true });
    }
  }, [isLogin])

  

  return (
  <>
    <Helmet>
      <title>Rechnungsexport</title>
    </Helmet>
    <Box
      sx={{
        // border: '1px dashed grey',
        backgroundColor: 'background.default',
        m: 2,
        py: 3
      }}
    >
    
       
            <MakeRechnung />
          
    
    </Box>
  </>
);

} 
export default RechnungDashboard;
